import { useEffect } from "react";

/**
 * Shows an error the server handed back in the URL, then removes it from the
 * address bar.
 *
 * A refused Google sign-in redirects here with `?error=` — "an account with
 * this email already exists, use your password", or "please accept the Terms
 * to create an account". Neither page read it, so those reasons reached the
 * URL and were never shown: the applicant just saw an unexplained sign-in
 * page. Removing it afterwards keeps a refresh from replaying a stale error.
 */
export function useRedirectError(show) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const message = params.get("error");
    if (!message) return;
    show(message);
    params.delete("error");
    const query = params.toString();
    window.history.replaceState(
      window.history.state,
      "",
      `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`
    );
  }, [show]);
}

export default useRedirectError;
